<button class="primary" (click)="abrirCalendario($event)" [disabled]="disabled">
  <ion-icon *ngIf="icon" [name]="icon"></ion-icon>
  <span>{{label}}</span>
</button>